import { useTheme } from '@dhl/theme'
import { SwipableDialogComponent } from './SwipableDialogComponent'
import { RegularDialogComponent } from './RegularDialogComponent'
import { type SwipeDialogProps } from './types'

/**
 * @deprecated The new design system provides a `Modal` component, available in `@dhl-ui/components`, which offers similar
 * functionality to this component. Only use this in apps/libs which have not yet migrated to the new design system.
 */
export const SwipeDialog = (props: SwipeDialogProps) => {
  const {
    device: { isMobile },
  } = useTheme()

  if (isMobile) {
    return <SwipableDialogComponent {...props} />
  }

  return <RegularDialogComponent {...props} />
}
